/* eslint-disable */
import jsrsasign  from 'jsrsasign'
import { privateKey } from './key'

export function getsign(signData) {
    var priK = `-----BEGIN PRIVATE KEY-----${privateKey}-----END PRIVATE KEY-----`
    //创建rsa实例
    var rsa = new jsrsasign.RSAKey()
    //因为后端提供的是pck#8的密钥对，所以这里使用 KEYUTIL.getKey来解析密钥
    rsa = jsrsasign.KEYUTIL.getKey(priK)
    // rsa.readPrivateKeyFromPEMString(priK);
    let sig = new jsrsasign.KJUR.crypto.Signature({"alg": "SHA256withRSA"});
    // 初始化
    sig.init(rsa)
    // 传入待加密字符串
    sig.updateString(signData)
    // 生成密文
    let sign = jsrsasign.hextob64(sig.sign());
    return sign
}


// WEBPACK FOOTER //
// ./src/axios/rsasign.js